import { ReturnAppSettings } from "@redotech/redo-customer-portal-shared/settings";
import { DraftReturn } from "@redotech/redo-model/draft-return/draft-return";
import { ProvisionType } from "@redotech/redo-model/return-flow";
import Lightning from "@redotech/redo-web/icon-old/lightning.svg";
import RadioFilled from "@redotech/redo-web/icon-old/radio-filled.svg";
import RadioUnfilled from "@redotech/redo-web/icon-old/radio-unfilled.svg";
import ShippingBox from "@redotech/redo-web/icon-old/shipping-box.svg";
import { memo } from "react";
import { subInLineBreaks } from "../../util/util";
import * as review from "../review.module.css";

export const ProvisionSelection = memo(function ProvisionSelection({
  draftReturn,
  settings,
  newOrderMethod,
  setNewOrderMethod,
}: {
  draftReturn: DraftReturn;
  settings: ReturnAppSettings;
  newOrderMethod: ProvisionType;
  setNewOrderMethod: (method: ProvisionType) => void;
}) {
  return (
    <div>
      <div className={review.subheader}>Choose new order method</div>
      <div className={review.exchangeBoxes}>
        <div
          className={
            newOrderMethod === ProvisionType.PROCESSED
              ? review.exchangeBoxSelected
              : review.exchangeBox
          }
          onClick={() => setNewOrderMethod(ProvisionType.PROCESSED)}
        >
          <div style={{ display: "flex", gap: "16px" }}>
            {newOrderMethod === ProvisionType.PROCESSED ? (
              <RadioFilled />
            ) : (
              <RadioUnfilled />
            )}
            <div style={{ display: "flex", gap: "4px", alignItems: "center" }}>
              <ShippingBox />
              <div>Standard Exchange</div>
            </div>
          </div>
          <div className={review.orderMethodText}>
            {settings.theme.standardExchangeText ? (
              subInLineBreaks(settings.theme.standardExchangeText)
            ) : (
              <p>
                You must ship your return item first before your new package
                gets sent to you.
              </p>
            )}
          </div>
        </div>
        <div
          className={
            newOrderMethod === ProvisionType.INSTANT
              ? review.exchangeBoxSelected
              : review.exchangeBox
          }
          onClick={() => setNewOrderMethod(ProvisionType.INSTANT)}
        >
          <div style={{ display: "flex", gap: "16px" }}>
            {newOrderMethod === ProvisionType.INSTANT ? (
              <RadioFilled />
            ) : (
              <RadioUnfilled />
            )}
            <div style={{ display: "flex", gap: "4px", alignItems: "center" }}>
              <Lightning />
              <div>Instant Exchange</div>
            </div>
          </div>
          <div className={review.orderMethodText}>
            {settings.theme.instantExchangeText ? (
              subInLineBreaks(settings.theme.instantExchangeText)
            ) : (
              <p>
                Get it fast! Your exchange order may be placed before the old
                items are returned.
              </p>
            )}
          </div>
        </div>
      </div>
    </div>
  );
});
